<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.08938 5.40698L8.68299 11.1764C9.43704 11.8362 10.563 11.8362 11.317 11.1764L17.9106 5.40698C17.9687 5.59436 18 5.79352 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6C2 5.79352 2.03129 5.59436 2.08938 5.40698ZM3.57124 4.04607C3.70936 4.0159 3.85283 4 4 4H16C16.1472 4 16.2906 4.0159 16.4288 4.04607L10 9.67123L3.57124 4.04607Z"
  />
</svg>
